import { useState, useEffect } from "react"
import { useApolloClient, useQuery } from "@apollo/client"
import { EledoStructure, EledoStructuresData, EledoStructuresVars, GET_STRUCTURES } from "graphql/EledoStructureQueries"


function useEledoStructures({connectionId, limit, page}: EledoStructuresVars) {
  const client = useApolloClient()
  const { loading, error, data } = useQuery<EledoStructuresData, EledoStructuresVars>(GET_STRUCTURES, {variables:{connectionId, limit, page}})
  const [structures, setEledoStructures] = useState<EledoStructure[]>([])
  const [total, setTotal] = useState<number>(0)
  const [structuresLoading, setEledoStructuresLoading] = useState<boolean>(false)

  useEffect(() => {
    if (loading){
      setEledoStructuresLoading(true)
      return
    }

    const _connections: EledoStructure[] = data?.structures.items.map(log => structuredClone(log)) || []

    setEledoStructures(_connections)
    setTotal(data?.structures.total || 0)
    setEledoStructuresLoading(loading)
  }, [data, client, loading])

  return { structuresLoading, error, structures, total }
}


export default useEledoStructures